export default __webpack_public_path__ + "static/media/landing-page-2.7113216a.jpg";